import { Box, Grid2 } from "@mui/material";
import InputComponent from "components/appInput";
import CustomModalRegister from "components/concert/modalRegister";
import React, { useRef, useState } from "react";
import "./index.scss";
import {
  useRequestOTPRegistration,
  useSubmitOTPRegistration,
} from "hooks/event";
import useInfoContext from "hooks/useInfoContext";

const ModalLoginUser = ({ open, handleClose, step, setStep, clientInfo }) => {
  const [phoneNumberUser, setPhoneNumberUser] = useState();
  const [phoneNumberError, setPhoneNumberUserError] = useState();
  const [errorOtpCode, setErrorOtpCode] = useState();
  const [otpValues, setOtpValues] = useState(new Array(5).fill(""));
  const [otpToken, setOtpToken] = useState();
  const iranPhoneRegex = /^(\+98|0)?9\d{9}$/;
  const { mutate: sendPhoneNumber } = useRequestOTPRegistration();
  const { repToken, setUserIdRegistration } = useInfoContext();
  const inputRefs = useRef([]);
  const { mutate: submitOTPRegistration } = useSubmitOTPRegistration();
  const [loginUserStatus, setLoginUserStatus] = useState(0);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && e.target.value === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;
      setOtpValues(newOtpValues);

      if (value.length >= 1 && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
      const otpCode = newOtpValues.join("");
      if (otpCode.length === 5) {
        handleSendOtp(otpCode);
      }
      setErrorOtpCode("");
    }
  };

  const handleSendOtp = (otpCode) => {
    if (otpCode.length < 5) {
      setErrorOtpCode("لطفا تمام کد ارسال را وارد کنید.");
    } else {
      submitOTPRegistration(
        { otp: otpCode, otpToken: otpToken, repToken: repToken },
        {
          onSuccess: (data) => {
            if (data?.status === "OK") {
              setStep(data?.userStage);
              setUserIdRegistration(data?.userId);
            } else if (data?.status === "Invalid Pin!") {
              setErrorOtpCode("کد وارد شده صحیح نمیباشد.");
            }
          },
          onError: (err) => {
            console.log("error in inside onError", err);
          },
        }
      );
    }
  };

  const handlephoneNumber = (value) => {
    setPhoneNumberUser(value);
    let formatedNumber = value.replace(/[^0-9]/g, "");
    formatedNumber = `${formatedNumber}`;
    setPhoneNumberUser(formatedNumber);
  };

  const sendNumberUser = () => {
    if (loginUserStatus === 0) {
      if (iranPhoneRegex.test(phoneNumberUser) && repToken) {
        sendPhoneNumber(
          { phoneNumber: phoneNumberUser, repToken },
          {
            onSuccess: (data) => {
              if (data?.status === "OK") {
                setOtpToken(data?.otpToken);
                setPhoneNumberUserError("");
                setLoginUserStatus(1);
              }
            },
            onError: (err) => {
              if (err.response.data.message === "USER ALREADY REGISTERED!") {
                setPhoneNumberUserError(
                  "شماره وارد شده رزرو کنسرت را انجام داده است"
                );
              }
            },
          }
        );
      } else {
        setPhoneNumberUserError("شماره وارد شده اشتباه است");
      }
    }
    if (loginUserStatus === 1) {
      const otpCode = otpValues.join("");
      handleSendOtp(otpCode);
    }
  };
  return (
    <CustomModalRegister
      open={open}
      handleClose={handleClose}
      title="افزودن همراه"
      activeStep={loginUserStatus}
      titleBody={loginUserStatus===0?"برای افزودن همراه ، شماره موبایل ایشان را وارد کنید":"کد تاییدی که به شماره موبایل همراهتان ارسال شد را وارد کنید"}
      buttonFunction={sendNumberUser}
      disabledButton={!phoneNumberUser}
      buttonText="ارسال کد تایید"
    >
      <Grid2 item size={{ xs: 12 }}>
        {loginUserStatus === 0 && (
          <InputComponent
            type="number"
            value={phoneNumberUser}
            placeholder="شماره موبایل"
            handleValue={handlephoneNumber}
            error={phoneNumberError}
            alertText={phoneNumberError}
            dir={"rtl"}
          />
        )}
        {loginUserStatus === 1 && (
          <>
            <Grid2 item size={{ xs: 12 }} className="box-input-otp">
              {Array.from({ length: 5 }).map((_, index) => (
                <input
                  key={index}
                  type="number"
                  inputMode="numeric"
                  maxLength="1"
                  ref={(el) => (inputRefs.current[index] = el)}
                  value={otpValues[index]}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  style={{ outline: "none" }}
                  className={`input-otp ${errorOtpCode ? "error" : ""}`}
                  autoFocus={!index}
                />
              ))}
            <Box className="otp-modal-alert">
              <span>{errorOtpCode}</span>
            </Box>
            </Grid2>
          </>
        )}
      </Grid2>
    </CustomModalRegister>
  );
};

export default ModalLoginUser;
